<template>
  <div class="is-marginless is-paddingless" v-if="lotPaiement">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getFormatCodeLotPaiement }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right">
          <div class="buttons">
            <dropdownButton
              v-if="lotPaiement.etat === constantes.ENCOURS"
              type="is-addOrEdit"
              :actions="secondaryActions"
              :permission="constantes.LOT_PAIEMENT.maj"
              @click="() => { $router.push({ name: getNameRouteEdition,
                params: { id: lotPaiement.id }})}">
              {{ $t('general.button.edit') }}
            </dropdownButton>
            <button class="button is-addOrEdit mgl-7px" v-if="listMouvementLotPaiement.length !== 0"
                    :class="{'button-access-no-permission'
                    : !checkPermissions(constantes.LOT_PAIEMENT.maj)}"
                    @click="checkPermissions(constantes.LOT_PAIEMENT.maj)
                    ? popUpEtatLotPaiement = true : showPopUp()">
              {{ this.lotPaiement.etat === constantes.ENCOURS
              ? $t('detailLotPaiement.actions.validation')
              : $t('detailLotPaiement.actions.devalidation')}}
            </button>
            <verticalDotsDropdown
              v-if="displayVerticalDots"
              class="mgr-0 mgb-2"
              :dropdownItems="dropdownItems"
              :permission="constantes.LOT_PAIEMENT.maj"
              :isButton="true"/>
            <b-dropdown class="button is-bottom-left has-text-left">
              <div slot="trigger" class="right">
                <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                <b-icon icon="chevron-down" class="has-text-default"></b-icon>
              </div>
              <b-dropdown-item>
                <p class="has-text-icon-more is-size-7">
                  {{$t('remiseBancaire.titleAccesRapide')}}
                </p>
              </b-dropdown-item>
              <b-dropdown-item has-link>
                <router-link :to="{ name: 'l.comptabilite.journal_ecriture',
                           params: { ids: this.idsFactureAchat,
                           lotPaiementLibelle: this.lotPaiement.nom
                           + this.lotPaiement.num.toString() }}"
                             :class="{'text-access-no-permission':
                                   !checkPermissions(constantes.JOURNAL_ECRITURE.lecture)}"
                           classComposant="noTextDecoration">
                  {{ $t('remiseBancaire.visuAchat') }}
                </router-link>
              </b-dropdown-item>
            </b-dropdown>
            <button class="button" v-if="moduleDcf !== constantes.MODULE_TLPE"
                    @click="checkPermissions(constantes.LOT_PAIEMENT.editer) ?
                    ouverturePopUpEdition() : showPopUp()">
              <div>
                <b-icon icon="file-download" type="is-default"></b-icon>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpEtatLotPaiement" has-modal-card class="modal"
              @close="popUpEtatLotPaiement = false">
      <pop-up-prevention  :messHeader="messHeaderRemise"
                          :messFooter="messFooterRemise"
                          :cancel="cancelPopupRemise"
                          :validate="validatePopupRemise"
                          :isErrorPopup.sync="popUpDevalidationLotPaiement.error"
                          :messagesPopup="popUpDevalidationLotPaiement.messages"
                          :messagesChampsVide="popUpDevalidationLotPaiement.messagesChampsVide"
                          :champsVide="popUpDevalidationLotPaiement.champsVide"
                          oncancel="popUpEtatLotPaiement = false"
                          @no="popUpEtatLotPaiement = false"
                          @yes="changementStatusRemise()">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpSuppressionLotPaiement.show" has-modal-card class="modal"
              @close="popUpSuppressionLotPaiement.show = false">
      <pop-up-prevention  :messHeader="this.$t('detailLotPaiement.suppression.title')"
                          :labelCheckbox="this.$t('detailLotPaiement.suppression.checkbox')"
                          :cancel="this.$t('general.non')"
                          :validate="this.$t('general.oui')"
                          :isErrorPopup.sync="this.popUpSuppressionLotPaiement.error"
                          :messagesPopup="this.popUpSuppressionLotPaiement.messages"
                          @no="popUpSuppressionLotPaiement.show = false"
                          @yes="value => deleteLotPaiement(value)">
      </pop-up-prevention>
    </b-modal>
    <error-msg-component :messages="messages"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :error="error"
                         class="mgt-20px"
                         :title="'general.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="mgt-20px">
      <div class="tab is-marginless">
        <ul>
          <li @click="activeTab = 'detailLotPaiement'"
              :class="{'is-active': activeTab === 'detailLotPaiement'}">
            {{ $t('remiseBancaire.onglet.lotPaiement') }}
          </li>
          <li @click="activeTab = 'ecrituresComptaDetail'"
              :class="{'is-active': activeTab === 'ecrituresComptaDetail'}">
            {{ $t('remiseBancaire.onglet.ecritureCompta')}}
          </li>
          <li @click="activeTab = 'fichierVirement'"
              :class="{'is-active': activeTab === 'fichierVirement'}">
            {{ $t('detailLotPaiement.onglet.fichierVirement')}}
          </li>
        </ul>
      </div>
      <div>
        <component :is="activeTab"
                   ref="childComponent"
                   :isDetail="true"
                   :detail-lot-paiement="listMouvementLotPaiement"
                   :lot-paiement="lotPaiement"
                   :id="lotPaiement.id"
                   :dateDernierExport="lotPaiement.dernierExportComptable"
                   :ecritures="ecritures"
                   :moduleDcf="moduleDcf"/>
      </div>
    </div>
    <b-modal v-model="popUpEditionLotPaiement" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="choiceEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import edition from '@/api/edition/index';
import formatCodeRemiseBancaire from '@/services/remiseBancaire/creationCodeRemiseBancaire';
import {
  get,
  deleteLotPaiementEnCours,
  unValid as unvalidRemiseBancaire,
  valid as validRemiseBancaire,
  virementsSEPA,
} from '@/api/remiseBancaire';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { LOT_PAIEMENT } from '@/configuration/baux/permissionsBauxConf';
import { JOURNAL_ECRITURE } from '@/configuration/compta/permissionsComptaConf';
import { getByRemiseBancaire as getMouvement, getAll } from '@/api/mouvementClient';
import { ENCOURS } from '@/configuration/remiseBancaire/remiseBancaireConf';
import { LISTE_CHOICE_EDITION_LOT_PAIEMENT } from '@/configuration/lotPaiement/lotPaiementConf';
import messageErreur from '@/services/general/messageErreur';
import { generateByRemiseBancaire, getByRemiseBancaire } from '@/api/compta/ifEcriture';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import { SENS_ACHAT, MODULE_TLPE, MODULE_ACHAT } from '@/configuration/devisConf';
import ecrituresComptaDetail from '@/components/commun/ecritureComptable/ecrituresComptaDetail';
import detailLotPaiement from '@/components/baux/lotPaiement/c_ligneLotPaiement';
import { VIREMENT, LETTRE_CHEQUE } from '@/configuration/parametrage/modeReglementConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import validationVirementSepa from '@/services/baux/lotPaiement/validationVirementSepa';
import validationEditionLettreCheque from '@/services/baux/lotPaiement/validationEditionLettreCheque';
import validationSuppression from '@/services/baux/lotPaiement/validationSuppression';
import fichierVirement from '@/components/baux/lotPaiement/detail/fichierVirement';
import { TYPE_PAIEMENT } from '@/configuration/compta/ecritureConf';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import popUpEdition from '@/components/factures/p_edition';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { checkExercice } from '@/api/compta/exerciceComptable/index';
import validationEcriture from '@/services/ecritureComptable/validation';
import validationRemiseBancaire from '@/services/remiseBancaire/validation/validationRemiseBancaire';
import dropdownButton from '@/components/general/button/dropdownButton';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';

const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      lotPaiement: null,
      listMouvementLotPaiement: [],
      popUpEtatLotPaiement: false,
      popUpSuppressionLotPaiement: {
        show: false,
        error: false,
        messages: [],
      },
      activeTab: 'detailLotPaiement',
      constantes: {
        SENS_ACHAT,
        ENCOURS,
        LOT_PAIEMENT,
        VIREMENT,
        JOURNAL_ECRITURE,
        MODULE_TLPE,
      },
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      choiceEdition: [],
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      popUpEditionLotPaiement: false,
      idsFactureAchat: [],
      exerciceOk: true,
      errorsExercice: '',
      ecritures: [],
      popUpDevalidationLotPaiement: {
        error: false,
        messages: [],
        messagesChampsVide: [],
        champsVide: [],
      },
      moduleDcf: null,
    };
  },
  components: {
    breadcrumb,
    popUpPrevention,
    ecrituresComptaDetail,
    detailLotPaiement,
    errorMsgComponent,
    fichierVirement,
    popUpEdition,
    routerLinkBlank,
    dropdownButton,
    verticalDotsDropdown,
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async getFactureAchatIds() {
      const ids = [];
      this.listMouvementLotPaiement.forEach((mouvement) => {
        mouvement.lettrages.forEach((lettrage) => {
          if (lettrage.mouvementClient1Id === mouvement.id) {
            ids.push(lettrage.mouvementClient2Id);
          } else ids.push(lettrage.mouvementClient1Id);
        });
      });
      if (ids.length === 0) return;
      const response = (await getAll({
        query: { ids, societeId: this.societeActiveId },
        limit: NO_PAGINATION,
      })).data.result.items;
      response.forEach((mouvement) => {
        if (mouvement.factureId) this.idsFactureAchat.push(mouvement.factureId);
      });
      this.idsFactureAchat.push(this.lotPaiement.id);
    },
    setChoiceEdition() {
      let listeChoices = LISTE_CHOICE_EDITION_LOT_PAIEMENT;
      if ([VIREMENT, LETTRE_CHEQUE].includes(this.lotPaiement.modeReglement.actionAchat)) {
        listeChoices = listeChoices.filter((choice) => {
          return choice.actionAchat.includes(this.lotPaiement.modeReglement.actionAchat);
        });
      }
      this.choiceEdition = listeChoices;
    },
    async generateEcritureComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generateByRemiseBancaire({
          referencePieceId: this.lotPaiement.id,
          typeEcriture: TYPE_PAIEMENT,
        });
        this.ecritures = (await getByRemiseBancaire(
          this.lotPaiement.id,
          this.lotPaiement.sens,
        )).data.result;
        messageSucces(this.$t('remiseBancaire.messages.successGenerateEcriture'));
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    ouverturePopUpEdition() {
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      this.popUpEditionLotPaiement = true;
    },
    async generateVirementSepa() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        await virementsSEPA(this.lotPaiement.id);
        messageSucces(this.$t('detailLotPaiement.messages.success.virementSepa'));
        if (this.activeTab === 'fichierVirement') {
          await this.$refs.childComponent.updateAttachement();
        }
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationVirementSepa(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    changementStatusRemise() {
      if (this.lotPaiement.etat === ENCOURS) this.validationLotPaiement();
      else this.devalidationLotPaiement();
    },
    async devalidationLotPaiement() {
      const loadingComponent = this.$buefy.loading.open();
      this.popUpDevalidationLotPaiement.error = false;
      this.popUpDevalidationLotPaiement.messages = [];
      this.popUpDevalidationLotPaiement.messagesChampsVide = [];
      this.popUpDevalidationLotPaiement.champsVide = [];
      try {
        await unvalidRemiseBancaire(this.$route.params.id);
        messageSucces(this.$t('devalidationRemiseBancaire.messages.succesLotPaiement'));
        this.popUpEtatLotPaiement = false;
        this.lotPaiement = (await get(this.$route.params.id)).data.result;
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.popUpDevalidationLotPaiement.messages = validationRemiseBancaire(e.response,
            this.constantes.SENS_ACHAT);
          validationGeneral(this.$i18n, e.response, this.popUpDevalidationLotPaiement.champsVide,
            this.popUpDevalidationLotPaiement.messages,
            this.popUpDevalidationLotPaiement.messagesChampsVide, null);
          this.popUpDevalidationLotPaiement.error = true;
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async validationLotPaiement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await validRemiseBancaire(this.$route.params.id);
        messageSucces(this.$t('validationRemiseBancaire.messages.successLotPaiement'));
        this.popUpEtatLotPaiement = false;
        this.lotPaiement = (await get(this.$route.params.id)).data.result;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async deleteLotPaiement(checkValue) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteLotPaiementEnCours(this.$route.params.id, checkValue);
        messageSucces(this.$t('detailLotPaiement.messages.success.suppression'));
        this.popUpSuppressionLotPaiement.show = false;
        this.$router.push({ name: 'l.baux.lot_paiement' });
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          this.popUpSuppressionLotPaiement.error = true;
          validationSuppression(e.response, this.popUpSuppressionLotPaiement.messages);
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      }
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        const response = await edition({
          ids: [this.lotPaiement.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEditionLotPaiement = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationEditionLettreCheque(response, this.errorEdition.messages);
          this.errorEdition.haveError = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      }
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getFormatCodeLotPaiement() {
      return formatCodeRemiseBancaire(this.lotPaiement.num, this.lotPaiement.nom, SENS_ACHAT);
    },
    getNameRouteListe() {
      if (this.moduleDcf === MODULE_TLPE) return 'l.gabed.lot_paiement_recette';
      if (this.moduleDcf === MODULE_ACHAT) return 'l.achat.lot_paiements_factures';
      return 'l.baux.lot_paiement';
    },
    getNameBreadcrumbTitle() {
      if (this.moduleDcf === MODULE_TLPE) return this.$t('listeLotPaiement.titreRecette');
      if (this.moduleDcf === MODULE_ACHAT) return this.$t('listeLotPaiement.titreFactureAchat');
      return this.$t('detailLotPaiement.breadcrumb.listeLotPaiement');
    },
    getNameRouteEdition() {
      if (this.moduleDcf === MODULE_TLPE) return 'm.gabed.lot_paiement_recette';
      if (this.moduleDcf === MODULE_ACHAT) return 'm.achat.lot_paiements_factures';
      return 'm.baux.lot_paiement';
    },
    breadcrumb() {
      return [
        { title: this.$t('detailLotPaiement.breadcrumb.accueil'), route: this.$PAGE_DEFAULT, isActive: false },
        {
          title: this.getNameBreadcrumbTitle,
          route: { name: this.getNameRouteListe },
          isActive: false,
        },
        { title: this.getFormatCodeLotPaiement, route: '', isActive: true },
      ];
    },
    typeRemise() {
      return this.lotPaiement.etat === ENCOURS ? 'validationRemiseBancaire' : 'devalidationRemiseBancaire';
    },
    messHeaderRemise() {
      const typeRemise = this.typeRemise;
      return this.$t(`${typeRemise}.deleteLotPaiement`);
    },
    messFooterRemise() {
      return this.errorsExercice;
    },
    cancelPopupRemise() {
      const typeRemise = this.typeRemise;
      return this.$t(`${typeRemise}.no`);
    },
    validatePopupRemise() {
      const typeRemise = this.typeRemise;
      return this.$t(`${typeRemise}.yes`);
    },
    secondaryActions() {
      const actions = [];
      if (this.lotPaiement.etat === this.constantes.ENCOURS) {
        actions.push({
          label: this.$t('detailLotPaiement.actions.suppression'),
          action: () => { this.popUpSuppressionLotPaiement.show = true; },
        });
      }
      return actions;
    },
    displayVerticalDots() {
      return this.lotPaiement.etat !== this.constantes.ENCOURS
        || this.lotPaiement.modeReglement.actionAchat === this.constantes.VIREMENT;
    },
    dropdownItems() {
      const items = [];
      if (this.lotPaiement.etat !== this.constantes.ENCOURS) {
        items.push({
          action: () => this.generateEcritureComptable(),
          libelle: this.$t('remiseBancaire.generateEcriture'),
          id: 0,
        });
      }
      if (this.lotPaiement.modeReglement.actionAchat === this.constantes.VIREMENT) {
        items.push({
          action: () => this.generateVirementSepa(),
          libelle: this.$t('detailLotPaiement.actions.virementSepa'),
          id: 1,
        });
      }
      return items;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.lotPaiement = (await get(this.$route.params.id)).data.result;
      this.moduleDcf = this.lotPaiement.module;
      const listMouvementLotPaiement = (await getMouvement(this.lotPaiement.id)).data.result;
      listMouvementLotPaiement.forEach((item) => {
        item.selected = false;
        item.montant = item.debit - item.credit;
      });
      this.listMouvementLotPaiement = listMouvementLotPaiement;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: formatCodeRemiseBancaire(this.lotPaiement.num, this.lotPaiement.nom, this.sens) }));
      this.setChoiceEdition();
      await this.getFactureAchatIds();
      await checkExercice(this.lotPaiement.societeId, this.lotPaiement.dateRemise)
        .then(response => {
          this.exerciceOk = response.data.result.state;
          if (response.data.result.errors !== null && response.data.result.errors.length >= 1) {
            const messages = [];
            validationEcriture(this.$i18n, response.data.result.errors, messages);
            this.errorsExercice = this.$i18n.t(messages[0].message, messages[0].parametres);
          }
        });
      this.ecritures = (await getByRemiseBancaire(
        this.lotPaiement.id,
        this.lotPaiement.sens,
      )).data.result;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
